<script setup lang="ts">
import { computed, defineEmits, defineProps, watch } from 'vue'
import { SelectOption } from '../../typings'
import BaseInputWrapper from './BaseInputWrapper.vue'
import { useField } from 'vee-validate'

const props = defineProps<{
    modelValue?: string | boolean
    label: string
    name: string
    vertical?: boolean
    options: SelectOption[]
    required?: boolean
    required2?: boolean
    disabled?: boolean
    rules?: any
}>()

const { handleChange } = useField(props.name, props.rules, { initialValue: props.modelValue })

const emit = defineEmits(['update:modelValue'])

function updateValue(value) {
    handleChange(value)
    emit('update:modelValue', value)
}

watch(
    () => props.modelValue,
    (value) => {
        handleChange(value)
    }
)

const value = computed({
    get: () => props.modelValue,
    set: (value) => {
        updateValue(value)
    },
})
</script>
<template>
    <BaseInputWrapper :name="props.name" :label="props.label" :required="required" :required2="required2">
        <fieldset class="mt-4">
            <legend class="sr-only">{{ props.label }}</legend>
            <div
                class="space-y-4 sm:flex"
                :class="{
                    'sm:flex-col sm:space-y-3': vertical,
                    'sm:items-center sm:space-x-7 sm:space-y-0': !vertical,
                }">
                <div v-for="option in options" :key="option.key" class="flex items-center">
                    <input
                        :id="props.name + '_' + option.key"
                        v-model="value"
                        v-bind="$attrs"
                        :name="props.name"
                        type="radio"
                        :checked="option.key === value"
                        :disabled="props.disabled"
                        class="peer h-4 w-4 border-gray-300 text-gray-700 focus:ring-primary disabled:pointer-events-none disabled:text-gray-400 disabled:shadow-none"
                        :value="option.key" />
                    <label
                        :for="props.name + '_' + option.key"
                        class="ml-3 block text-sm font-medium text-gray-700 peer-disabled:text-gray-400">
                        {{ option.label }}
                    </label>
                </div>
            </div>
        </fieldset>
    </BaseInputWrapper>
</template>
